import React from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import Ppt from "./ppt";
import MainPage from "./main";
import Privacy from "./privacy";

const routes = [
  {
    path: "/cor/privacy-policy",
    element: <Privacy />
  },
  {
    path: "/whoweare/presentation",
    element: <Ppt />
  },
  {
    path: "/",
    element: <MainPage />
  },
];

export default function RouteConfigExample() {
  return (
      <Router>
        <Routes>
          {routes.map((route, i) => (
              <Route key={i} path={route.path} element={route.element} />
          ))}
        </Routes>
      </Router>
  );
}
